import type { UIMessage } from "ai";

/**
 * Whether the chat should show its typing indicator: the question was sent and no answer text is arriving. That covers the wait for the first reply and the time the Tutor spends calling tools, which streams parts that are not text. It is also true again when a tool call follows text the model already wrote. A step marker at the end is ignored
 * @param {UIMessage[]} messages - The conversation so far
 * @param {string} status - The chat's status (`submitted`, `streaming`, `ready`, or `error`)
 * @returns {boolean} True while the user is waiting for answer text
 */
const isAwaitingAnswerText = (
	messages: UIMessage[],
	status: string,
): boolean => {
	if (status === "submitted") return true;

	if (status !== "streaming") return false;

	const last = messages[messages.length - 1];

	if (!last || last.role !== "assistant") return true;

	const parts = last.parts.filter((part) => part.type !== "step-start");
	const lastPart = parts[parts.length - 1];

	return !(lastPart?.type === "text" && lastPart.text.length > 0);
};

export default isAwaitingAnswerText;
